<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/inventory')">Inventario y Actuaciones</a>
      <i class="right angle icon divider"></i>
      <a class="active section">Stock</a>
    </div>

    <div style="display:flex; justify-content: space-between;margin: calc(2rem - .14285714em) 0 1rem">
      <h1 class="ui header" style="float:left;margin:0px!important">
        <i class="dolly icon"></i>
        <div class="content">Stock Disponible</div>
      </h1>

      <button class="ui basic button" style="float:left" v-on:click="goTo('/inventory/stock/add')">
        <i class="add icon"></i>Nuevo Stock
      </button>
    </div>

    <div class="ui stackable">
      <div class="row">
        <h4 class="ui dividing header">Buscar Stock</h4>
        <div>
          <form class="ui form" @submit.prevent="searchStock">
            <div class="three fields">
              <div v-if="(role === 'master' || role === 'admin')" class="field">
                <sui-dropdown fluid multiple search selection :options="stockTypesOptions" v-model="search.stockType"
                  placeholder="Tipo Stock" />
              </div>
              <div v-if="(role === 'master' || role === 'admin')" class="field">
                <sui-dropdown fluid multiple search selection :options="stocksOptions" v-model="search.repuestos"
                  placeholder="Repuestos" />
              </div>
              <div v-if="(role === 'master' || role === 'admin')" class="field">
                <sui-dropdown fluid multiple search selection :options="columnsOptions" v-model="search.columnas"
                  placeholder="Columnas" />
              </div>
            </div>
            <div class="three fields">
              <div v-if="(role === 'master' || role === 'admin')" class="field">
                <sui-dropdown fluid multiple search selection :options="storesOptions" v-model="search.store"
                  placeholder="Almacen" />
              </div>
            </div>
            <div class="three fields">
              <div class="field">
              </div>
              <div class="field">
                <button class="ui button fluid black" type="submit">Buscar</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div v-if="(searching && rows.length == 0)" class="ui active centered inline loader"></div>
      <div v-if="(rows.length != 0)" class="row">
        <div class="column">
          <h4 class="ui dividing header">Stock disponible</h4>
          <vue-good-table ref="table" :columns="columns" :rows="rows" :group-options="{
            enabled: true,
            collapsable: true
          }" :sort-options="{
            enabled: false
          }" @on-row-click="stockInfo" styleClass="verticalAlignMiddle vgt-table striped condensed bordered"
            compactMode>
            <div slot="table-actions">
              <button class="ui button mini labeled icon right floated " @click="$refs.table.collapseAll()">
                <i class="caret right icon"></i>Contraer</button>
              <button class="ui button mini labeled icon right floated " @click="$refs.table.expandAll()">
                <i class="caret down icon"></i>Expandir</button>
            </div>
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'desglose'">
                <i v-if="props.row.desglose === true" class="eye icon"></i>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'stockList',
  data() {
    return {
      role: null,
      searching: null,
      search: {
        store: [],
        repuestos: [],
        columnas: [],
        stockType: [],
      },
      columns: [
        {
          label: 'Nombre',
          field: 'stock_name',
        },
        {
          label: 'Almacén',
          field: 'store_name',
        },
        {
          label: 'Cantidad',
          field: 'quantity',
        },
        {
          label: 'Reservas',
          field: 'reservations',
        },
        {
          label: 'Máquinas',
          field: 'apt_model',
        },
      ],
      rows: [],
      storesOptions: [],
      stocksOptions: [],
      columnsOptions: [],
      stockTypesOptions: [],
    }
  },
  created() {
    this.searching = false
    this.role = JSON.parse(localStorage.admin).role;
    if (this.role === 'master' || this.role === 'admin') {
      this.getDataFilters()
      this.getStocks()
      this.getStockTypes()
    } else {
      this.$router.replace('/inventory')
    }
  },
  methods: {
    getStockTypes() {
      this.axios.get("static/tipo_stock.json").then(response => {
        let stockTypes = response.data.stockTypes || [];
        let stockTypesOptions = stockTypes.map((e) => {
          return {
            text: e.text,
            value: e.key,
          }
        })

        this.stockTypesOptions = stockTypesOptions.sort((a, b) => {
          if (a.text < b.text) {
            return -1;
          }
          if (a.text > b.text) {
            return 1;
          }
          return 0;
        })
      })
        .catch((request) => console.log('error getting stock types: ' + request));
    },
    async getDataFilters() {
      await hapiickApi().post('/v2/shipments/filters', {
        admin_id: JSON.parse(localStorage.admin).id,
        Store: true
      })
        .then(request => {
          let stores = JSON.parse(JSON.stringify(request.data.data.stores));
          if (stores.length > 0) {
            this.fillStoresOptions(stores)
          } else {
            this.storesOptions.push({
              'text': 'No hay almacenes',
            })
          }
        })
        .catch(() => console.log('error getting combo informations'))
    },
    async getStocks() {
      await hapiickApi().post('/v1/stocks', {
        admin_id: JSON.parse(localStorage.admin).id,
      })
        .then(request => {
          let stocks = JSON.parse(JSON.stringify(request.data.stocks));
          if (stocks.length > 0) {
            this.fillStocksOptions(stocks)
          } else {
            this.stocksOptions.push({
              'text': 'No hay repuestos',
            })
            this.columnsOptions.push({
              'text': 'No hay columnas',
            })
          }
        })
        .catch((req) => {
          console.log('error getting stocks')
        })
    },
    searchStock() {
      for (const value in this.search) {
        if (this.search[value] === null || this.search[value] == 0) {
          delete this.search[value];
        }
      }

      this.searching = true
      this.rows = []

      hapiickApi().post('/v1/stocks/search', {
        admin_id: JSON.parse(localStorage.admin).id,
        search: this.search
      })
        .then((response) => {
          let stocks = JSON.parse(JSON.stringify(response.data.stocks))
          if (stocks.length == 0) {
            this.rows.push({
              'from': 'no encontrado',
            })
          } else {
            this.rows = stocks;
          }
        })
        .catch((err) => {
          this.$swal({
            type: 'error',
            title: 'Error',
            text: 'Error al obtener los datos.'
          })

          this.rows.push({
            'from': 'no encontrado',
          })
        })
    },
    fillStoresOptions(stores) {
      for (let i = 0; i < stores.length; i++) {
        this.storesOptions.push({
          id: stores[i].Store.id,
          key: stores[i].Store.key,
          text: stores[i].Store.name,
          value: stores[i].Store.id,
        })
      }
    },
    fillStocksOptions(stocks) {
      for (let i = 0; i < stocks.length; i++) {
        let stock = {}
        stock['id'] = stocks[i].id,
          stock['key'] = stocks[i].id,
          stock['value'] = stocks[i].id,
          stock['text'] = stocks[i].name

        if (stocks[i].stock_type === 'R') {
          this.stocksOptions.push(stock)
        } else {
          this.columnsOptions.push(stock)
        }
      }
    },
    stockInfo(params) {
      let routeData = this.$router.resolve('/inventory/stock/info/' + params.row.stock_id + '/' + params.row.store_id)
      window.open(routeData.href, '_blank')
    },
    goTo(where) {
      this.$router.push(where)
    }
  },
}
</script>

<style>
.verticalAlignMiddle td,
th {
  vertical-align: middle !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Inventory/stockList.vue